'use client';

import { useState } from 'react';
import { BaseTranslations } from '../../../baseTranslations';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { tr } from '../../../utils/translations/tr';
import { ProductDetailsExpandableList } from './ProductDetailsExpandableList';
import {
  ProductDetailsRowHeading,
  ProductDetailsRowHeadingLevel,
} from './ProductDetailsRowHeading';

type ProductDetailsAttributeListRowProps = {
  label: string;
  items: string[];
  headingLevel: ProductDetailsRowHeadingLevel;
  /** Bullet icon rendered in front of every item (e.g. the Quick Facts brand mark). */
  icon?: JSX.Element;
};

/** Titled bullet list with "see more" (key-value, payment-network and multi-text attributes). */
export const ProductDetailsAttributeListRow: React.FC<
  ProductDetailsAttributeListRowProps
> = ({
  label,
  items,
  headingLevel,
  icon,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="flex flex-col gap-spacing/gap/x"
      data-component="pdp-configured-list-row"
    >
      <ProductDetailsRowHeading level={headingLevel}>
        {label}
      </ProductDetailsRowHeading>
      <ProductDetailsExpandableList
        list={items}
        expanded={expanded}
        onToggle={() => setExpanded((value) => !value)}
        icon={icon}
        seeMoreText={tr('see_more_pd', staticText)}
        seeLessText={tr('see_less_pd', staticText)}
      />
    </div>
  );
};
